import React, { Fragment } from 'react';
import dataService from '../../services/dataService';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import LocalShippingIcon from '@material-ui/icons/LocalShippingOutlined';

class RouteList extends React.PureComponent {
  render() {
    const { onSelect, data, highlightedRoute, onRouteHover } = this.props;
    return (
      <>
        <div className="flex flex-row space-between route-info selectedRouteHeader">
          <span>{Math.round(data.totalDistance / 1609.34)} mi</span>
          <span>{data.routes.length} routes</span>
          <span>{data.totalStops} stops</span>
        </div>
          <List
            className="fullwidth"
            style={{ maxHeight: '100%', overflow: 'auto' }}
          >
            {data.routes.map(route => (
              <Fragment key={route.id}>
                <ListItem
                  alignItems="flex-start"
                  onClick={() => onSelect('route', route.id)}
                  onMouseOver={() => onRouteHover(route.id)}
                  className={`flex flex-row pointer route-item ${highlightedRoute == route.id ? 'highlighted-route' : ''}`}
                >
                  <LocalShippingIcon color="action" fontSize="large" className="route-icon" />
                  <div className="flex flex-column fullwidth">
                    <div className="fullwidth route-desc">Route <span>{route.id}</span></div>
                    <div className="fullwidth flex flex-row driver-info">
                      <span>{route.driver.fullName}</span>
                      <span className="driver-label">{route.driver.id}</span>
                    </div>
                    <div className="route-info">
                      <span>{`${Math.round(route.distance / 1609.34)} mi`}</span>
                      <span>{`${Math.round(route.duration / 60)} min`}</span>
                      <span>{`${route.stops.length} stops`}</span>
                    </div>
                  </div>
                </ListItem>
                <Divider />
              </Fragment>
            ))}
          </List>
      </>
    );
  }
}

export default RouteList;
